import { createAction } from 'redux-actions'

let settings_set     = createAction('SETTINGS_SET')
let settings_reset   = createAction('SETTINGS_RESET')

export {settings_set, settings_reset}

export let settings_set_use_status_date = flag => settings_set({key: 'look_ahead_use_status_date', value: flag})




// WEBPACK FOOTER //
// ./src/actions/settings.js